import React, { PureComponent } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

class Spinner extends PureComponent {
  render() {
    return (
      <div className="spinner--container">
        <CircularProgress size={50} />
      </div>
    );
  }
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner.js